(() => {
  if (window.__afTimeline) { window.__afTimeline(); return; }
  let frame = 0;
  const update = () => {
    frame = 0;
    document.querySelectorAll('#af-landing [data-af-timeline]').forEach(path => {
      const rect = path.getBoundingClientRect();
      const target = window.innerHeight * .72;
      const progress = Math.max(0, Math.min(1, (target - rect.top - 27) / Math.max(1, rect.height - 54)));
      path.style.setProperty('--af-progress', progress.toFixed(4));
      path.querySelectorAll('.af-timeline__stage').forEach(stage => {
        stage.classList.toggle('is-reached', stage.getBoundingClientRect().top + 28 <= target);
      });
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  window.__afTimeline = schedule;
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:block:select', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
